import { createContext } from 'react';
import {
  IFunctionalContext,
  IPurchaseContext,
  IQuoteCartContext,
} from '~/purchase/types';
export const FunctionalContext = createContext<IFunctionalContext | undefined>(
  undefined,
);
export const PurchaseContext = createContext<IPurchaseContext | undefined>(
  undefined,
);
export const QuoteCartContext = createContext<IQuoteCartContext | undefined>(
  undefined,
);
export const CustomerSelectorAvailabilityContext =
  createContext<boolean>(false);
